import script from "./ClassroomLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomLayout.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomLayout.vue?vue&type=style&index=0&id=0ddbf696&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ddbf696"]])

export default __exports__